(($) => {

    const main_bar = $('.header .mainbar');

    // scrolling behaviour, filter row stuff relates to filter_row JS, filters stuck to top
    let prev_scroll_pos = $(window).scrollTop();
    let is_scrolled_up = false;
    $(window).scroll(function(){
        var current_scroll_pos = $(window).scrollTop();
        let mainbar_height = $('header .mainbar').height();

        if('.post-type-archive-catalogue'){
            return;
        }

        if(prev_scroll_pos > current_scroll_pos){
            $(main_bar).css("margin-top", "0");
            main_bar.data('scrolled', false);
            is_scrolled_up = false;
        }else if (current_scroll_pos > prev_scroll_pos + (mainbar_height / 2)){
            $(main_bar).css("margin-top", '-' + mainbar_height + 'px');
            main_bar.data('scrolled', true);
            is_scrolled_up = true;
        }
        prev_scroll_pos = current_scroll_pos;
    });

    $(window).on('resize', function(){
        $(main_bar).css("margin-top", "0");
        main_bar.data('scrolled', false);
        is_scrolled_up = false;
    });

    // /**
    //  * Adjusts the position of an element to scroll with the header.
    //  *
    //  * @param {string} element_div - The selector for the element that should scroll with the header.
    //  * @param {string} next_div - The selector for the element immediately following the scrolling element.
    //  * @param {boolean} alter - A flag indicating whether to alter the margin of the next element.
    //  * @param {boolean} [checkWidth=true] - A flag indicating whether to check the window width before applying the scroll behavior.
    //  */
    function element_scrolls_with_header(element_div, next_div, alter, checkWidth = true) {
        if ($(element_div)[0]) {
            const element = $(element_div);
            const element_after = $(next_div);
    
            function updateElementPosition() {
                let element_top = element_after.offset().top;
                let filter_row_height = element.outerHeight();
                let viewport_top = $(window).scrollTop();
                let topbar_height = $('.topbar').outerHeight();
                let mainbar_height = $('.mainbar').outerHeight();
    
                if (viewport_top > element_top) {
                    element.addClass('active');
                    if (alter) {
                        element_after.css('margin-top', filter_row_height);
                    }
                } else {
                    element.removeClass('active');
                    if (alter) {
                        element_after.css('margin-top', 'unset');
                    }
                }
    
                if (element.hasClass('active')) {
                    element.css('top', is_scrolled_up ? topbar_height : topbar_height + mainbar_height);
                }
            }
    
            function main_behaviour() {
                if (!checkWidth || $(window).width() > 1299) {
                    updateElementPosition();
                }
            }
    
            main_behaviour();
    
            $(window).on('scroll', main_behaviour);
            $(window).on('resize', function() {
                setTimeout(main_behaviour, 200);
            });
        }
    }
    
    element_scrolls_with_header('.filter_row', '.products-posts-content', true);
    element_scrolls_with_header('.pageNavigationMain', '.article-main-col', false, false);

    function closeHeaderMenu(){
        $('.primary_dropdown, .menu_dropdowns, .primary_overlay, .equipment__part_a__item, .equipment__part_b__item, .equipment__dropdown__part_b, .equipment__dropdown__part_c').removeClass('active');
    }

    $(window).on('resize', function(){
        if(window.innerWidth < 1280){
            closeHeaderMenu();
        }
        if($('.nav').hasClass('active')){
            $('.primary_overlay').addClass('active');
        }
    });

    $('.mainbar__links__item').on("mouseover", function(){
        let classList = $(this).attr('class').split(' ');
        let modifierClass = classList.find(cls => cls.startsWith('mainbar__links__item--'));
        $('.primary_dropdown').removeClass('active');
        $('.menu_dropdowns').removeClass('active');
        
        if(modifierClass){
            let modifier = modifierClass.replace('mainbar__links__item', '');
            $('.primary_dropdown' + modifier).addClass('active');
            $('.primary_overlay').addClass('active');
            $('.menu_dropdowns').addClass('active');
        }
    });

    $('.primary_overlay, .topbar, .mainbar__image, .mainbar__buttons').on("mouseover", function(e){
        if(window.innerWidth >= 1280){
            closeHeaderMenu();
        }
    });

    $('.menu_dropdowns').on("mouseover", function(e){
        if(e.target === this){
            closeHeaderMenu();
        }
    });

})(jQuery);